import type { RoomFault } from '@taxwar/net'

/** The room transport failed or was used after it closed: the match ends in a "connection lost" state (docs/ARCHITECTURE.md §13). */
export class TransportError extends Error {
  override readonly name = 'TransportError'
}

/** The room reported its own failure (an uncaught sim/host error) and stopped: the app shows the crash report (§13). */
export class RoomFaultError extends Error {
  override readonly name = 'RoomFaultError'

  constructor(readonly fault: RoomFault) {
    super(`room fault: ${fault.name}: ${fault.message}`)
    // The room-side stack is the useful one; the client-side construction site says nothing.
    this.stack = `${this.name}: ${this.message}\n${fault.stack}`
  }
}
